/* @jsx mdx */
import React from 'react'
import { mdx } from '@mdx-js/react'

import { Cite, Slide, Heading, Text, Box, FlexBox, Image, Appear, Markdown } from "spectacle";
import {LeftContentRightContent, LeftCodeRightContent, LeftCodeRightMarkdown, LeftContentRightMarkdown, LeftCodeRightCode} from "components/layout";
import useSelector from "./examples/useSelector";
import useDispatch from "./examples/useDispatch";

function MDXContentWrapperSlide0(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const TitleDummy = makeShortcode("TitleDummy");
const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    {
      /* prettier-ignore-start */
    }
    {
      /* prettier-ignore-end */
    }
    <TitleDummy mdxType="TitleDummy" />
    <h1>{`React-Redux`}</h1>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide0.isMDXComponent = true;

function MDXContentWrapperSlide1(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */






const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>{`React-Redux v7`}</h4>
    <ul>
      <li parentName="ul">{`Goals:`}
        <ul parentName="li">
          <li parentName="ul">{`v6 architecture tried to use context for state propagation, which had performance problems`}</li>
          <li parentName="ul">{`Switch back to per-component Redux store subscriptions for better performance`}</li>
          <li parentName="ul">{`Enable future implementation of a React-Redux hooks API`}</li>
        </ul>
      </li>
      <li parentName="ul">{`Behavior and implementation:`}
        <ul parentName="li">
          <li parentName="ul">{`Rewrote `}<inlineCode parentName="li">{`connect`}</inlineCode>{` using React hooks API + internal Redux store subscriptions`}</li>
          <li parentName="ul">{`Used React renderer batching from ReactDOM and React Native`}</li>
          <li parentName="ul">{`Released in spring 2019`}</li>
        </ul>
      </li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide1.isMDXComponent = true;

function MDXContentWrapperSlide2(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */






const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>{`React-Redux v7.1: Hooks!`}</h4>
    <ul>
      <li parentName="ul">{`Goal: eventually design and ship a public `}<inlineCode parentName="li">{`useRedux()`}</inlineCode>{`-type hooks API`}
        <ul parentName="li">
          <li parentName="ul">{`Bikeshedding issue thread: `}<a parentName="li" {...{
              "href": "https://github.com/reduxjs/react-redux/issues/1179"
            }}>{`Issue #1179: Discussion: Potential Hooks API Design`}</a></li>
          <li parentName="ul">{`Extensive discussions around potential API designs and implementation constraints`}</li>
        </ul>
      </li>
      <li parentName="ul">{`Behavior and implementation:`}
        <ul parentName="li">
          <li parentName="ul">{`Settled on two primary hooks: `}<inlineCode parentName="li">{`useSelector`}</inlineCode>{` and `}<inlineCode parentName="li">{`useDispatch`}</inlineCode></li>
          <li parentName="ul">{`Unlike `}<inlineCode parentName="li">{`connect`}</inlineCode>{`, cannot enforce top-down nested subscriptions`}</li>
          <li parentName="ul">{`Reference (`}<inlineCode parentName="li">{`===`}</inlineCode>{`) equality checks for selectors instead of shallow equality`}</li>
          <li parentName="ul">{`No action creator binding`}</li>
          <li parentName="ul">{`No automatic wrapping of components to avoid re-renders from props`}</li>
        </ul>
      </li>
      <li parentName="ul"><strong parentName="li">{`We now recommend using the hooks API as the default approach`}</strong>
        <ul parentName="li">
          <li parentName="ul"><inlineCode parentName="li">{`connect`}</inlineCode>{` is supported indefinitely, but no plans for further changes`}</li>
        </ul>
      </li>
      <li parentName="ul">{`The hooks API has a different set of tradeoffs than `}<inlineCode parentName="li">{`connect`}</inlineCode>{` does:`}
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://blog.isquaredsoftware.com/2019/07/blogged-answers-thoughts-on-hooks/"
            }}>{`Thoughts on React Hooks, Redux, and Separation of Concerns`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://blog.isquaredsoftware.com/2019/09/presentation-hooks-hocs-tradeoffs/"
            }}>{`ReactBoston 2019: Hooks, HOCs, and Tradeoffs`}</a></li>
        </ul>
      </li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide2.isMDXComponent = true;

function MDXContentWrapperSlide3(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */






const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>{`React-Redux: `}<inlineCode parentName="h4">{`useSelector()`}</inlineCode></h4>
    <LeftCodeRightMarkdown leftSource={useSelector} mdxType="LeftCodeRightMarkdown">{`
- Extracts a value from the Redux state for use in this component
  - Accepts a "selector" function as its argument
  - Subscribes to the store and re-runs the selector whenever the store state changes
- Differences from \`connect\` and \`mapState\`:
  - Uses reference equality by default (also takes an optional equality comparison argument)
  - Can be called multiple times in one component
  - Don't have to return an object (and should prefer returning single values)
`}</LeftCodeRightMarkdown>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide3.isMDXComponent = true;

function MDXContentWrapperSlide4(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */






const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>{`React-Redux: `}<inlineCode parentName="h4">{`useDispatch()`}</inlineCode></h4>
    <LeftCodeRightMarkdown leftSource={useDispatch} mdxType="LeftCodeRightMarkdown">{`
- Returns the store's \`dispatch\` method
- Differences from \`connect\` and \`mapDispatch\`:
  - Equivalent to calling \`connect\` with no \`mapDispatch\` argument
  - No "binding action creators" any more - up to you to call \`dispatch()\` in your own handlers
`}</LeftCodeRightMarkdown>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide4.isMDXComponent = true;

function MDXContentWrapperSlide5(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */






const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>{`React-Redux vNext?`}</h4>
    <ul>
      <li parentName="ul">{`Current version: v7.2`}
        <ul parentName="li">
          <li parentName="ul">{`Stable, no immediate plans for changes`}</li>
        </ul>
      </li>
      <li parentName="ul">{`Long-term question: Concurrent Mode and Suspense`}
        <ul parentName="li">
          <li parentName="ul">{`External state tools will have issues with Concurrent Mode because React wants to own state updates and reorder them`}</li>
          <li parentName="ul">{`React team created `}<a parentName="li" {...{
              "href": "https://github.com/reactjs/rfcs/pull/147"
            }}>{`new experimental `}<inlineCode parentName="a">{`useMutableSource`}</inlineCode>{` hook`}</a>{` specifically for use with external state tools like Redux`}</li>
        </ul>
      </li>
      <li parentName="ul">{`Will likely build React-Redux v8 around `}<inlineCode parentName="li">{`useMutableSource`}</inlineCode>{` whenever CM finally is ready`}
        <ul parentName="li">
          <li parentName="ul">{`Not 100% sure that `}<inlineCode parentName="li">{`connect`}</inlineCode>{` will be fully CM-compat (might just take extra work)`}</li>
        </ul>
      </li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide5.isMDXComponent = true;

function MDXContentWrapperSlide6(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */






const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>{`A Deep Dive into React-Redux`}</h4>
    <br />
    <h5>{`Mark's Dev Blog: `}<br />{` `}<strong parentName="h5"><a parentName="strong" {...{
          "href": "https://blog.isquaredsoftware.com/2018/11/react-redux-history-implementation/"
        }}>{`The History and Implementation of React-Redux`}</a></strong></h5>
    <ul>
      <li parentName="ul">{`Integrating Redux with a UI`}
        <ul parentName="li">
          <li parentName="ul">{`What does React-Redux even do for you, and why do we need "UI bindings" in the first place?`}</li>
          <li parentName="ul">{`What does `}<inlineCode parentName="li">{`connect`}</inlineCode>{` do internally?`}</li>
        </ul>
      </li>
      <li parentName="ul">{`Development History of the React-Redux API`}
        <ul parentName="li">
          <li parentName="ul">{`Initial design constraints`}</li>
          <li parentName="ul">{`API and implementation changes over time`}</li>
        </ul>
      </li>
      <li parentName="ul">{`Implementation characteristics of v4, v5, v6, v7, and v7.1 with hooks`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide6.isMDXComponent = true;

function MDXContentWrapperNotes0(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */






const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes0.isMDXComponent = true;

function MDXContentWrapperNotes1(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */






const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes1.isMDXComponent = true;

function MDXContentWrapperNotes2(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */






const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes2.isMDXComponent = true;

function MDXContentWrapperNotes3(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */






const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes3.isMDXComponent = true;

function MDXContentWrapperNotes4(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */






const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes4.isMDXComponent = true;

function MDXContentWrapperNotes5(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */






const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes5.isMDXComponent = true;

function MDXContentWrapperNotes6(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */






const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes6.isMDXComponent = true;


export const notes = [MDXContentWrapperNotes0,MDXContentWrapperNotes1,MDXContentWrapperNotes2,MDXContentWrapperNotes3,MDXContentWrapperNotes4,MDXContentWrapperNotes5,MDXContentWrapperNotes6];


export default [MDXContentWrapperSlide0,MDXContentWrapperSlide1,MDXContentWrapperSlide2,MDXContentWrapperSlide3,MDXContentWrapperSlide4,MDXContentWrapperSlide5,MDXContentWrapperSlide6]